import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import Routers from './router';
//import store from './store';
//import iView from 'iview';
//import markdown from 'vue-markdown';
import ElementUI from 'element-ui';
import hljs from 'highlight.js';
import prism from 'prismjs';
import "./libs/dark.css";

Vue.use(ElementUI);
Vue.use(hljs);
Vue.use(prism);
Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: Routers
};


Vue.config.productionTip = false
const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
});